import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import { Form } from "devextreme-react";
import { SimpleItem } from "devextreme-react/form";
import { Label } from "devextreme-react/chart";
import { alignmentType, positionType } from "./data";
import ButtonOKCancel from "./ButtonOKCancel";
import { updateDataLabelAlignmentPosition } from "./Redux/dataLabelSlice";

export default function DataLabelAlignmentContainer(props) {
  const { dataLabelAlignmentPopupRef } = props;

  const formRef = useRef(null);

  const dispatch = useDispatch();

  const alignmentEditorOptions = {
    items: alignmentType,
    showClearButton: true,
  };

  const positionEditorOptions = {
    items: positionType,
    showClearButton: true,
  };

  const onCancelClick = (e) => {
    dataLabelAlignmentPopupRef.current.instance.hide();
  };

  const onOkClick = (e) => {
    dispatch(
      updateDataLabelAlignmentPosition(
        formRef.current.instance.option("formData")
      )
    );

    dataLabelAlignmentPopupRef.current.instance.hide();
  };

  return (
    <React.Fragment>
      <Form ref={formRef}>
        <SimpleItem
          dataField="alignment"
          editorType="dxSelectBox"
          editorOptions={alignmentEditorOptions}
        >
          <Label text="정렬" />
        </SimpleItem>
        <SimpleItem
          dataField="position"
          editorType="dxSelectBox"
          editorOptions={positionEditorOptions}
        >
          <Label text="위치" />
        </SimpleItem>
      </Form>
      <ButtonOKCancel onCancelClick={onCancelClick} onOkClick={onOkClick} />
    </React.Fragment>
  );
}
